'use client';

import { API_ROUTES, useApiInvalidate } from '@shared/api-utils';
import { useCallback } from 'react';

function useInvalidatePurchasedTickets() {
  const { invalidateQueriesStartingWith, invalidateQueriesMatchingPath } = useApiInvalidate();

  const invalidatePurchasedTickets = useCallback(() => {
    void invalidateQueriesStartingWith(API_ROUTES.LOTTERIES.PURCHASES);
    // The drawing id sits in the path, so a query-key prefix cannot match every drawing the results page has cached.
    void invalidateQueriesMatchingPath(API_ROUTES.LOTTERIES.PURCHASED_DRAWING_TICKETS.split(':drawingId')[0]!);
  }, [invalidateQueriesMatchingPath, invalidateQueriesStartingWith]);

  return { invalidatePurchasedTickets };
}

export { useInvalidatePurchasedTickets };
